import React from "react";
import { connect } from 'react-redux';
import {
  Card,
  CardHeader,
  CardTitle,
  Row,
  Col,
  CardBody,
  CardFooter,
  NavLink,
  UncontrolledTooltip
} from "reactstrap";

import {
  PanelHeader,
  Statistics,
  Stats,
  CardDescription,
  CardStats,
  CardCategory,
  Timeline,
  CardIcon,
  Button,
  Tasks
} from "components";
import ButtonWithTooltip from '../../components/Custom/ButtonWithTooltip';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import User from '../../entities/User';
import { projectService } from '../../services';
import Switch from "react-bootstrap-switch";
import { widgetStories, tasks } from "variables/general";
import ErrorModal from "../Components/ErrorModal";
import { Link } from 'react-router-dom';
import { permissions } from '../../helpers';
import { loopbackActions, projectActions, userActions } from "../../actions";
import { permissionConstants } from "../../constants";
import { history } from '../../helpers';
import { refreshHeader } from '../../components/Header/Header';


class DashboardComponent extends React.Component {

  constructor(props) {
    super(props);
    // let prjs = localStorage.getItem('projects');
    // let projects = prjs && JSON.parse(prjs);
    this.state = {
      errors: [],
      projects: null,
      lightpoints: [],
      cabinets: []
    }
    this.shouldSeeUsersTotal = permissions.grant(permissionConstants.SHOW_USERS);
  }

  componentWillMount() {
    this.fetchProjects();
  }

  async fetchProjects() {
    try {
      let filter = {
        include: 'users'
        // where: {
        //     members: {
        //         like: "%\"" + userId + "\"%"
        //     }
        // }
      };
      const user = User.current();
      //let projects = await projectService.getAll(filter);
      let projects = await projectService.getAllByUser(user);
      if (permissions.grant('SHOW_ONLY_OWN_PROJECTS')) {
        //const user = User.current();

        /*projects = projects.filter((project) => {
          for (const cur of project.users) {
            if (cur.id == user.id) {
              return true;
            }
          }
          return false;
        });*/

        // const userId = user.id;
        // filter = { 
        //     where: {
        //         members: {
        //             like: "%\"" + userId + "\"%"
        //         }
        //     }
        // };
      }

      // let args = [];
      // projects.map((project)=>{
      //     args.push({
      //         path: "plant",
      //         model: "alarms",
      //         projectId: project.id,
      //         where: { projectId: project.id, ackByUser: { neq: null} },
      //     });
      // });

      // // leggo il numero di allarmi per ogni progetto
      // let results = args.map(async (arg) => await loopbackService.count(arg.path, arg.model, arg.where, arg.projectId));
      // let alarmsCount = {};
      // for (let i = 0; i < results.length; i++) {
      //     const projectId = args[i].projectId;
      //     try {
      //         let count = await results[i];
      //         alarmsCount[projectId] = { count };
      //     } catch (response) {
      //         let error = null;
      //         if (typeof(response.json)=='function')
      //             error = await response.json();
      //         else 
      //             error = response;
      //         console.log(error);
      //     }
      // }

      // console.log('conto allarmi', alarmsCount);


      localStorage.setItem('projects', JSON.stringify(projects));
      setTimeout(() => { refreshHeader(projects); }, 0);
      this.setState({ projects });
      this.fetchData(projects);
    } catch (err) {
      console.log(err);
    }
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.loopback) {
      const { cabinets, lightpoints, alarms } = nextProps.loopback;
      this.setState({ cabinets, lightpoints, alarms });
    }

    // if (this.state.projects==null && nextProps.projects.items){
    //     let projects = nextProps.projects.items;
    //     this.setState( projects );
    //     setTimeout(()=>{
    //       this.fetchData( projects );
    //     },0);

    // }


    // if (nextProps.errors && nextProps.errors.length>0){
    //   for (const item of nextProps.errors){
    //     if (item.error.error && item.error.error.statusCode===401){
    //       history.push('/pages/login-page');
    //       return;
    //     }
    //   }
    //   this.setState({ errors: nextProps.errors });
    // }

  }


  fetchData(projects) {
    const dispatch = this.props.dispatch;
    //const { projects } = this.state;
    let args = [];
    if (projects) {
      projects.map((project) => {
        args.push({ path: 'plant', model: 'cabinets', where: null, projectId: project.id });
        args.push({ path: 'plant', model: 'lightpoints', where: null, projectId: project.id });
        args.push({ path: 'plant', model: 'alarms', where: { ackByUserId: null }, projectId: project.id });
      });

      dispatch(loopbackActions.multiCount(args));
    }
  }


  jumpTo(dest, selectedProjectId){
      localStorage.setItem('selectedProjectId',selectedProjectId);
      refreshHeader(null);
      history.push(dest);
  }

  render() {

    const { userOwnedProjectsCount, userOwnedUsersCount } = this.props;
    const { t, i18n } = this.props;
    const { errors, projects, cabinets, lightpoints, alarms } = this.state;

    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          {errors.length > 0 &&
            <ErrorModal error={errors} onClickHandler={() => { this.setState({ errors: [] }); }} />
          }
          {projects && projects.map((project, key) =>

            <Row key={key}>
              <Col xs={12} md={12} lg={12} className="text-center ">
                <Card className="">
                  <CardBody className="project-title">
                    <div className="prj-label" >
                      <i className="project-title-icon now-ui-icons travel_info " />
                      <div className="project-title-body">
                        <h5> { project.name } </h5>
                        {project.description && <p >{project.description}</p>}
                      </div>
                    </div>
                    <div className="prj-actions" >
                            <NavLink 
                                id = { "nav_"+project.id }
                                className = "nav-link"
                                onClick = { () => { 
                                  this.jumpTo('/navigator',project.id);
                                }} 
                            >
                              <i className="now-ui-icons circle location_pin" />
                              <UncontrolledTooltip placement={"left"} target = { "nav_"+project.id } delay = {0} >
                                { t("Navigatore") } 
                              </UncontrolledTooltip>
                            </NavLink>
                    </div>
                    <div className="prj-actions" >
                            <NavLink 
                                id = { "eve_"+project.id }
                                className = "nav-link"
                                onClick = { () => { this.jumpTo('/events_log',project.id); }} 
                            >
                              <i className="now-ui-icons circle files_paper" />
                              <UncontrolledTooltip placement={"left"} target = { "eve_"+project.id } delay = {0} >
                                { t("Eventi") } 
                              </UncontrolledTooltip>

                            </NavLink>
                    </div>
                    <div className="prj-actions" >
                            <NavLink 
                                id = { "sta_"+project.id }
                                className = "nav-link"
                                onClick = { () => { this.jumpTo('/stats',project.id); }} 
                            >
                              <i className="now-ui-icons circle business_chart-bar-32" />
                              <UncontrolledTooltip placement={"left"} target = { "sta_"+project.id } delay = {0} >
                                { t("Statistiche") } 
                              </UncontrolledTooltip>

                            </NavLink>
                    </div>
                    
                  </CardBody>
                  <hr style={{ padding: 0, margin: 0 }} />
                  <CardFooter>
                    <Row >
                      <Col xs={4} className="project-info" >
                        <h2>{(cabinets && cabinets[project.id] && cabinets[project.id].count) ? cabinets[project.id].count : '-'}</h2>
                        <h5>{t('Cabine')}</h5>
                      </Col>
                      <Col xs={4} className="project-info" style={{}}>
                        <h2>{(lightpoints && lightpoints[project.id] && lightpoints[project.id].count) ? lightpoints[project.id].count : '-'}</h2>
                        <h5>{t('Punti Luce')}</h5>
                      </Col>
                      <Col xs={4} className="project-info" style={{ color: (alarms && alarms[project.id] && alarms[project.id].count>0 ? "red" : "lightgray") }}>
                        <h2>{(alarms && alarms[project.id] && alarms[project.id].count) ? alarms[project.id].count : '-'}</h2>
                        <h5><i className="now-ui-icons ui-1_bell-53" style={{ verticalAlign: "middle" }} />&nbsp;{t("Allarmi")}</h5>
                      </Col>

                    </Row>
                  </CardFooter>
                </Card>
              </Col>
            </Row>

          )}

        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, loopback, projects } = state;
  return {
    loggedinUser: authentication.user,
    loopback,
    projects
  };
}

const Dashboard = withTranslation()(connect(mapStateToProps)(DashboardComponent));
export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx